import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { ServerMaintenanceSchedule } from 'src/app/api/common/models/server-maintenance-schedule.model';
import { AuthorizationService } from 'src/app/api/common/services/authorization.service';
import {
  LINK_FOR_HELP,
  LINK_FOR_USER_MANUAL_PDF,
  LOGIN_TYPE_B2C,
  LOGIN_TYPE_INTERNAL,
} from 'src/app/constants/app.constant';
import { AuthService } from 'src/app/services/authorization/auth.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SignInComponent {
  showAlert: boolean = false;
  environmentText: String =
    environment.envVersion !== '' ? '[' + environment.envVersion + ']' : '';
  maintenanceSchedule: ServerMaintenanceSchedule[] = [];
  underMaintenance: boolean = false;
  haveMaintenance: boolean = false;

  // linkForHelp: string = 'https://scg.service-now.com/myrequestscg';
  linkForHelp: string = LINK_FOR_HELP;
  linkForUserManualPDF: string = environment.linkForUserManualPDF;
  linkCreateAccount: string = environment.linkCreateAccount;

  /**
   * Constructor
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _authService: AuthService,
    private _router: Router,
    private _msalService: MsalService,
    private authorizationService: AuthorizationService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.getMaintenanceSchedule();
    if (!environment.requireAuthen) {
      setTimeout(() => {
        this._authService.manageLastActivity();
        this.signInMSAL();
      }, 100);
    }
  }

  getMaintenanceSchedule(): void {
    this.authorizationService.postCheckMaintenance().subscribe((result) => {
      if (result.isSuccess) {
        this.maintenanceSchedule = result.data;
        this.underMaintenance = this.maintenanceSchedule.some(
          (item) => item.effective
        );
        this.haveMaintenance = this.maintenanceSchedule.length > 0;
      }
    });
  }

  showMaintenanceSchedule(): void {
    var swal_html = '<table class="w-100 table table-bordered swal-table">';
    swal_html += '<thead><tr>';
    swal_html += this.genSwalTableTh('Impacted Module');
    swal_html += this.genSwalTableTh('Start');
    swal_html += this.genSwalTableTh('End');
    swal_html += this.genSwalTableTh('Block Access');
    swal_html += this.genSwalTableTh('Block Menu');
    swal_html += '</tr></thead>';
    swal_html += '<tbody>';
    this.maintenanceSchedule.forEach((item) => {
      swal_html += '<tr>';
      swal_html += this.genSwalTableTd(
        item.system === null || item.system === '' ? 'All' : item.system,
        item.effective
      );
      swal_html += this.genSwalTableTd(item.start, item.effective);
      swal_html += this.genSwalTableTd(item.end, item.effective);
      swal_html += this.genSwalTableTd(
        item.blockAccess ? 'Yes' : '',
        item.effective
      );
      swal_html += this.genSwalTableTd(
        item.blockMenu ? 'Yes' : '',
        item.effective
      );
      swal_html += '</tr>';
    });
    swal_html += '</tbody></table>';
    Swal.fire({
      width: 800,
      showCloseButton: true,
      showConfirmButton: false,
      title: 'Maintenance Schedule',
      html: swal_html,
    });
  }

  genSwalTableTh(text: string) {
    return '<th class="">' + text + '</th>';
  }

  genSwalTableTd(text: string | undefined, active: boolean = false): string {
    if (active) {
      return '<td class="table-success">' + text + '</td>';
    } else {
      return '<td class="">' + text + '</td>';
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
  isLogedIn(): boolean {
    return this._msalService.instance.getActiveAccount() != null;
  }

  async signInMSAL() {
    if (!environment.requireAuthen) {
      setTimeout(() => {
        this._router.navigate(['/']);
      }, 100);
    } else {
      // this._msalService.loginRedirect();
      await this._authService.signInMSAL();
    }
    // this._authService.loginType = LOGIN_TYPE_INTERNAL;
    // setTimeout(() => {
    // }, 100);
    // this.msalService.loginPopup().subscribe({
    //   next: (response: AuthenticationResult) => {
    //     this.msalService.instance.setActiveAccount(response.account);
    //   },
    // });
  }

  async signInMSALB2C() {
    if (!environment.requireAuthen) {
      setTimeout(() => {
        this._router.navigate(['/']);
      }, 100);
    } else {
      // this._msalService.loginRedirect();
      await this._authService.signInMSALB2C();
    }
    // this._authService.loginType = LOGIN_TYPE_B2C;
    // setTimeout(() => {
    // }, 100);
  }

  async resetPasswordMSAL() {
    if (!environment.requireAuthen) {
      console.log('reset password');
    } else {
      await this._authService.b2cResetPassword();
    }
  }

  logout(): void {
    this._authService.signOut();
    this._authService.signOutMsal();
    this._router.navigate(['sign-in']);
  }
}
